import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("rt_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const api = client;
export const API_URL = API;

export function fmtErr(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(", ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
